// Runtime config, resolved at BUILD time from Vite env vars (never hardcoded).
// `||`, not `??`: docker-compose passes every unset build arg as an EMPTY
// string, and Vite then sees "" which `??` would keep. An empty value must
// mean "use the default".

/** Production backend — the only API a production build talks to unless a
 * build explicitly overrides it (E2E builds point it at a local backend). */
export const PROD_API_BASE_URL = 'https://api.wnfexchange.com'

/** Backend base URL — `api.wnfexchange.com` (FastAPI rewrite of the legacy
 * `api-wnfexchange-com` App Engine app). A production build without
 * `VITE_API_BASE_URL` still targets the live API, so the prod image never
 * depends on an operator-supplied build variable; `npm run dev` defaults to
 * a local backend. */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || (import.meta.env.PROD ? PROD_API_BASE_URL : 'http://localhost:8000')

/** Auth0 login popup entry point — `GET /user/login/auth0` on the backend,
 * the same BFF route the sibling UIs use (screener, GrabbitBot portal,
 * payment back-office). The backend does the OIDC code exchange
 * (state + nonce bound) and hands a session token back to the opener via
 * postMessage; this SPA never accepts a token from anywhere else.
 * Live since api.wnfexchange.com 0.6.0 (batch W6); the Auth0 "Bot" app
 * carries WnF Exchange's callback + origin (ticket d8175f66). While the
 * backend's Auth0 values are unset it answers 503 `auth0_not_configured`. */
export const AUTH0_LOGIN_URL: string = import.meta.env.VITE_AUTH0_LOGIN_URL || `${API_BASE_URL}/user/login/auth0`

/** Origin the Auth0-login popup's `postMessage` reply must come from
 * (checked inside `Auth0LoginButton`). Defaults to the API's own origin. */
export const AUTH0_LOGIN_EXPECTED_ORIGIN: string =
  import.meta.env.VITE_AUTH0_LOGIN_ORIGIN || new URL(API_BASE_URL).origin

/** App build version, injected by Vite from package.json (single source). */
export const APP_VERSION: string = __APP_VERSION__

/** Where a successful login sends the user next: the wallet list — the
 * legacy app's start screen for this product. */
export const POST_LOGIN_PATH = '/wallets'

/** Trading type — WnF Exchange is spot only (legacy `:tradingType/wallets`
 * routes always carried `spot`). */
export const TRADING_TYPE = 'spot'

/** Brand name — always "WnF Exchange" in user-facing text (owner rule
 * 2026-09-29: "WnF" alone is the company name, not the product). */
export const BRAND = 'WnF Exchange'

/** Role string the admin gate looks for (no admin screen ships in round 1). */
export const ADMIN_ROLE = 'admin'
